import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center full-width" }, "Không tìm thấy kết quả nào.", -1)
const _hoisted_2 = { class: "q-mx-md" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Trước ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Tiếp ")
const _hoisted_5 = { class: "pt-1" }

import { ref, onMounted, Ref, withDefaults, computed, watch } from 'vue'
  import { DataTableColumn, DataTablePagination } from 'src/models/common';
  import {ApiResponseList, Params} from 'src/models/api';
  import { apiRequest, buildParams } from 'src/services/infs/apiRequest';
  import { useQuasar } from 'quasar';
  import { formatDate } from 'src/services/utils/date';
  import { LateInterestCustomer } from 'src/models/customers';

      
export default /*#__PURE__*/_defineComponent({
  name: 'AppDataTable',
  props: {
    columns: null,
    source: null,
    useBy: { default: '' },
    hideBottom: { type: Boolean, default: false },
    params: { default: {} },
    change: { default: 0 },
    separator: { default: 'cell' },
    stickyLastCol: { type: Boolean, default: false },
    mobileMode: { type: Boolean, default: true },
    isClickableRow: { type: Boolean, default: false }
  },
  emits: ['totalRow', 'onClickRow', 'getAllResults', 'getAllData'],
  setup(__props: any, { emit }) {

const props = __props as { columns: DataTableColumn[], source: string, useBy: string, hideBottom: boolean, params: Params, change: number, separator: string, stickyLastCol: boolean, mobileMode: boolean, isClickableRow: boolean }

  
      
      const $q = useQuasar();
      const rows: Ref<object[]> = ref([]);
      const loading = ref(false);
      const pagination: Ref<DataTablePagination> = ref({
        page: 0,
        rowsPerPage: 0,
        rowsNumber: 0,
        from: 0,
        to: 0
      });
      const isPaged = computed(() => {
        return !Object.values(pagination.value).includes(0);
      });
      const paginationLabel = (firstRowIndex: number, endRowIndex: number, totalRowsNumber: number) => {
        return `${firstRowIndex}-${endRowIndex} của ${totalRowsNumber}`;
      };
      const filter = computed(() => {
        let params = {...props.params};
        if (isPaged.value) {
          params = {...params, page: pagination.value.page, limit: pagination.value.rowsPerPage}
        }
        return buildParams(params);
      });

      const fetchData = () => {
        loading.value = true;
        const url = `${String(props.source)}${String(filter.value)}`;
        apiRequest(url, 'get')
            .then((res: ApiResponseList) => {
              rows.value = res.data.results || [];
              
              if (props.useBy == 'detail-last-interest' && res.data.results.length > 0) {
                rows.value = formatResults(res.data.results);
              }
              
              pagination.value.page = res.data.current_page || 0;
              pagination.value.rowsPerPage = res.data.per_page || 0;
              pagination.value.rowsNumber = res.data.total || 0;
              pagination.value.to = res.data.to || 0;
              pagination.value.from = res.data.from || 0;
              emit('totalRow', pagination.value.rowsNumber || 0);
              emit('getAllResults', res.data.results || []);
              emit('getAllData', res.data || []);
            })
            .catch(() => {
                rows.value = [];
            })
          .finally(() => {
            loading.value = false;
          })
      };

      const changePage = (page?: number) => {
        if (!!page) pagination.value.page = page;
        fetchData();
      };

      const onRequest = (scope: {pagination: DataTablePagination}) => {
        pagination.value = scope.pagination;
        fetchData();
      };

      onMounted(() => {
        fetchData();
        $q.lang.table.allRows = '15';
      });

      watch(() => props.change, () =>{
        fetchData();
      });

      const formatResults = (results: LateInterestCustomer[]) => {
        return results.map((item: LateInterestCustomer) => {
          if (item.last_remind_at) {
            item.last_remind_at = formatDate(item.last_remind_at, 'DD-MM-YYYY');
          }
          return item;
        });
      }


return (_ctx: any,_cache: any) => {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    class: _normalizeClass(["data-table sticky-header", {'sticky-last': __props.stickyLastCol, 'remove-pointer': !__props.isClickableRow}]),
    rows: rows.value,
    columns: __props.columns,
    "row-key": "id",
    pagination: pagination.value,
    "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((pagination).value = $event)),
    loading: loading.value,
    "hide-bottom": __props.hideBottom,
    onRequest: onRequest,
    "binary-state-sort": "",
    separator: __props.separator,
    onRowClick: _cache[4] || (_cache[4] = (event, row) => __props.isClickableRow ? _ctx.$emit('onClickRow', row, event) : ''),
    "rows-per-page-label": "Hiển thị",
    "pagination-label": paginationLabel,
    "rows-per-page-options": [5, 10, 20, 50, 100],
    bordered: __props.separator === 'cell',
    grid: __props.mobileMode && _unref($q).screen.lt.sm
  }, _createSlots({
    "no-data": _withCtx(() => [
      _hoisted_1
    ]),
    item: _withCtx((scope) => [
      _createVNode(_component_q_card, { class: "w-full mb-4 p-4 space-y-4" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.cols, (col) => {
            return (_openBlock(), _createElementBlock("div", {
              key: col.name
            }, [
              _createVNode(_component_q_item_label, { class: "text-gray-400 text-xs" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(col.label), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, `body-cell-${col.name}`, _normalizeProps(_guardReactiveProps(scope)), () => [
                  _createTextVNode(_toDisplayString(col.value), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _: 2
      }, 1024)
    ]),
    _: 2
  }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
        ])
      }
    }),
    (_unref(isPaged))
      ? {
          name: "pagination",
          fn: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(pagination.value.from) + " đến " + _toDisplayString(pagination.value.to) + " của " + _toDisplayString(pagination.value.rowsNumber), 1),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              disable: scope.isFirstPage,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(pagination.value.page - 1))),
              class: "q-mr-md"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  class: "q-mr-sm",
                  name: "angle-left-b"
                }),
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["disable"]),
            _createVNode(_component_q_pagination, {
              modelValue: pagination.value.page,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((pagination.value.page) = $event)),
                changePage
              ],
              "max-pages": 6,
              max: scope.pagesNumber
            }, null, 8, ["modelValue", "max"]),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              disable: scope.isLastPage,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(pagination.value.page + 1))),
              class: "q-ml-md"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_app_icon, {
                  class: "q-ml-sm",
                  name: "angle-right-b"
                })
              ]),
              _: 2
            }, 1032, ["disable"])
          ])
        }
      : undefined
  ]), 1032, ["class", "rows", "columns", "pagination", "loading", "hide-bottom", "separator", "bordered", "grid"]))
}
}

})